export class IvsFragments {
    static etfPriceMin = `
    price
    {
      asOfDate
      navPrice
      navPriceChange
      navPricePercentChange
      closingPrice
    }
  `;
    static etfPriceAll = `
    price
    {
      asOfDate
      navPrice
      navPriceChange
      navPricePercentChange
      closingPrice
      __typename
    }
  `;
    static etfMain = `
    ticker
    name
    inceptionDate
    shortName
    morningStarCategoryName
    assetClassName
    broadAssetClass
    transparencyTypeName
    grossExpenseRatio
    taxID
    netExpenseRatio
    publicOfferingDate
  `;
    static etfMainAll = `
    ticker
    name
    inceptionDate
    shortName
    grossExpenseRatio
    publicOfferingDate
    netExpenseRatio
    transparencyTypeName
    assetClassName
    broadAssetClass
    morningStarCategoryName
    taxID
    __typename
`;
    static averageAnnualTotalReturns = `
    averageAnnualTotalReturns
    {
      quarterly
      {
        asOfDate
        fundPerformance
        {
          performanceType
          navQuarterlyYtdReturn
          navOneYearReturn
          navThreeYearAnnualizedReturn
          navFiveYearAnnualizedReturn
          navTenYearAnnualizedReturn
          navSinceInceptionReturn
          navSinceInceptionAnnualizedReturn
          marketPriceQuarterlyYtdReturn
          marketPriceOneYearReturn
          marketPriceThreeYearAnnualizedReturn
          marketPriceFiveYearAnnualizedReturn
          marketPriceTenYearAnnualizedReturn
          marketPriceSinceInceptionReturn
          marketPriceSinceInceptionAnnualizedReturn
          __typename
        }
      __typename
      }
      __typename
    }
  `;
    static etfData = `
    ${this.etfMain}
    ${this.etfPriceMin}
  `;
    static allETFs = `
      ${this.etfMainAll}
      ${this.etfPriceAll}
      ${this.averageAnnualTotalReturns}
  `;
}
//# sourceMappingURL=ivs-api.fragments.js.map